import script from "./AddTransactionSetup.vue?vue&type=script&setup=true&lang=js"
export * from "./AddTransactionSetup.vue?vue&type=script&setup=true&lang=js"

import "./AddTransactionSetup.vue?vue&type=style&index=0&id=766e29ce&lang=css"

const __exports__ = script;

export default __exports__